// AtomParts/Description.tsx
import React from "react";

interface DescriptionProps {
  children: React.ReactNode;
}

const Description: React.FC<DescriptionProps> = ({ children }) => (
  <p className="text-base text-primary-700">{children}</p>
);

export default Description;
